import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterSociete extends ISearchLimitOffset {
    Societe?: string;
    SortField?: string;
    IsDescending?:boolean;
  }


  export const getDefaultFilterSociete = (): IFilterSociete => ({
    Societe:undefined,
    Offset: 0,
    Limit: 10,
    SortField: "Societe",
    IsDescending: true,
  });
  
  export const filterToQuery = (filter: IFilterSociete): IFilterSociete => {
    const dto: IFilterSociete = {};
 
    if (filter?.Societe !== undefined ) {
      dto.Societe = filter.Societe;
    } 

    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterSocietes", JSON.stringify(dto));
  
    return dto;
  };
  
  export const dtoToFilter = (dto: IFilterSociete): IFilterSociete => {
  
    return {
      Societe: dto.Societe,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      SortField: dto.SortField,
    };
  };
 